import { ICellRendererParams } from 'ag-grid-community';
import styles from './roundPositionCell.module.scss';

const RoundPositionCell = ({ value }: Partial<ICellRendererParams>) => {
  const { roundName, collectionPosition, isDualMatch } = value;
  const collectionPositionValue = collectionPosition || '/';
  const roundNameValue = roundName || '/';

  return (
    <span className={styles.roundPosition}>
      {isDualMatch ? collectionPositionValue : roundNameValue}
    </span>
  );
};

export { RoundPositionCell };
